// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1h5IY","text":"SelectPayment_text__2nd8T","title":"SelectPayment_title__2FUFA","btn":"SelectPayment_btn__1XvIV"};